import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Grid,
  Button,
  useMediaQuery
} from '@mui/material';
import { ExternalLink } from '../../../components';
import { BASE_FILE_URL } from '../util';

export const PreferredVendors = () => {
  const isMobile = useMediaQuery('(max-width: 960px)');
  const gridSize = isMobile ? 12 : 6;

  return (
    <Box>
      <Typography variant="h3" sx={{ mt: 4 }}>
        Preferred Vendors
      </Typography>
      <Typography variant="body1" sx={{ mb: 5 }}>
        To help you feel confident in caring for your new home, we’ve compiled a list of preferred
        vendors. These are the experts we trust and use ourselves, ready to provide dependable
        service whenever you need it.
      </Typography>
      <Box sx={{ maxWidth: 800, margin: '0 auto' }}>
        {preferredVendors.map(vendor => {
          return (
            <Accordion key={vendor.name}>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{vendor.name}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  {vendor.links.map(link => (
                    <Grid item xs={gridSize} key={link.name}>
                      <Button
                        variant="contained"
                        component={ExternalLink}
                        to={link.linkUrl}
                        type="smallWhite"
                        target="_blank"
                      >
                        {link.name}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    </Box>
  );
};

const preferredVendors = [
  {
    name: 'Waynes Environmental',
    links: [
      {
        name: 'Customer Portal Login',
        linkUrl: 'https://callwaynes.key7app.com/User/Login',
        linkText: 'Visit Site'
      }
    ]
  },
  {
    name: 'Sensigreen Heating & Air',
    links: [
      {
        name: 'Comfort Care Application (Year 2+)',
        linkUrl: `${BASE_FILE_URL}/Comfort_Care_Application.pdf`,
        linkText: 'View PDF'
      },
      {
        name: 'Accessory Brochure',
        linkUrl: `${BASE_FILE_URL}/Sensigreen_Accessory_Brochure.pdf`,
        linkText: 'View PDF'
      },
      {
        name: 'Maintenance Information',
        linkUrl: 'https://www.sensigreen.com/maintenance',
        linkText: 'View PDF'
      },
      {
        name: 'Sensigreen Comfort Care Information (Year 1)',
        linkUrl: `${BASE_FILE_URL}/Sensigreen_Comfort_Care_Information_Year_1.pdf`,
        linkText: 'View PDF'
      },
      {
        name: 'HVAC Registration',
        linkUrl: `${BASE_FILE_URL}/HVAC_Registration.pdf`,
        linkText: 'View PDF'
      }
    ]
  },
  {
    name: 'PPG',
    links: [
      {
        name: '25% Off Coupon',
        linkUrl: `${BASE_FILE_URL}/PPG_25_Off_Coupon.pdf`,
        linkText: 'View PDF'
      },
      {
        name: 'Free Gallon Coupon',
        linkUrl: `${BASE_FILE_URL}/PPG_Free_Gallon_Coupon.pdf`,
        linkText: 'View PDF'
      }
    ]
  },
  {
    name: 'Lambert Moving Systems',
    links: [
      {
        name: 'Moving Incentive',
        linkUrl: `${BASE_FILE_URL}/Moving_Discount_Flyer.pdf`,
        linkText: 'View PDF'
      }
    ]
  },
  {
    name: 'Prism Blinds',
    links: [
      {
        name: 'Prism Blinds Information',
        linkUrl: `${BASE_FILE_URL}/Prism_Blinds_Information.pdf`,
        linkText: 'View PDF'
      }
    ]
  }
];
